const cache = new WeakMap();

export const createResizeListener = ({
  selectorFn,
  fireEventFn,
  hasConnectWrapper
}) => {
  try {
    const entryPoint = selectorFn();

    if (!entryPoint || cache.has(entryPoint)) {
      return;
    }

    const sendDimensions = () => {
      const height = entryPoint.offsetHeight;
      const width = entryPoint.offsetWidth;
      const payload = {
        height,
        width
      };
      if (!height || !width) {
        // not initialised yet, don't send anything;
        return;
      }
      fireEventFn(payload, 'widget');

      if (hasConnectWrapper) {
        fireEventFn(payload, 'wrapper');
      }
    };

    const resizeObserver = new ResizeObserver(() => {
      sendDimensions();
    });

    const mutationObserver = new MutationObserver(() => {
      sendDimensions();
    });

    cache.set(entryPoint, { resizeObserver, mutationObserver });

    resizeObserver.observe(entryPoint);
    mutationObserver.observe(entryPoint, {
      attributes: true,
      attributeFilter: ['style', 'class', 'open', 'aria-expanded', 'hidden']
    });
    sendDimensions();

    return () => {
      cache.delete(entryPoint);
      resizeObserver.unobserve(entryPoint);
      mutationObserver.disconnect();
    };
  } catch (error) {
    // can't really do anything here so just swallow the error and continue without resize events
  }
};
